import styled from '@emotion/styled';
import VerticalMoveIcon from 'src/assets/icons/VerticalMoveIcon';

export const CompetitionsList = styled('ul', { label: 'CompetitionsList' })`
    height: 690px;
    list-style-type: none;
    margin: 0;
    overflow-y: scroll;
    padding: 0;
`;

export const CompetitionsListItem = styled('li', { label: 'CompetitionsListItem' })<{ isDragged: boolean }>`
    background-color: #eee;
    border: 1px solid rgba(0, 0, 0, .2);
    color: #333;
    cursor: pointer;
    font-size: 12px;
    padding: 8px 10px;
    width: 100%;
    z-index: ${(props): string => props.isDragged ? '10001' : 'inherit'};
    list-style-type: none;

    :hover,:focus {
        background: #f3f3f3;
    }
`;

// SportCompetitionsItem
export const ItemButton = styled('span', { label: 'ItemButton' })<{ isDragged: boolean }>`
    cursor: ${(props): string => props.isDragged ? 'grabbing' : 'grab'};
    display:flex;
`;

export const ItemWrapper = styled('div', { label: 'ItemWrapper' })`
    justify-content: space-between;
`;


export const VerticalMoveIconWrapper = styled(VerticalMoveIcon, { label: 'VerticalMoveIconWrapper' })`
    position: absolute;
    right: 10px;
    top: 13px;
`;
